<template>
  <div id="shopping-submit">
    <div class="wrap">
      <div class="wrap_zh">
        <div class="shopping-title">
          <div class="shopping-title_name fl">我的售后订单</div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="wrap_zh shopping-orderdetail">
        <div class="shopping-orderdetail-top fl">
          <div class="shopping-orderdetail-top_infos fl">
            <span>
              下单时间：
              <font>{{goodsInfo.createDate}}</font>
            </span>
            <span>
              订单编号：
              <font>{{goodsInfo.orderNo}}</font>
            </span>
          </div>
          <div class="shopping-orderdetail-top_btn fr">
            <el-button
              plain
              class="shoppingbtn-plan shopp-btn-default"
              @click="operaOldOrderDetails"
            >查看原订单</el-button>
            <el-button
              plain
              class="shoppingbtn-plan shopp-btn-default shopp-return"
              @click="operaConfirm('confirmReturnAddress')"
              v-if="goodsInfo.orderType == 4 && goodsInfo.orderStatus == 3"
            >查看退货地址</el-button>
            <el-button
              plain
              class="shoppingbtn-plan shopp-btn-danger"
              @click="operaConfirm('confirmGetGoods')"
              v-if="goodsInfo.orderType == 3 && goodsInfo.orderStatus == 4"
            >确认收货</el-button>

            <el-button
              plain
              class="shoppingbtn-plan shopp-btn-danger"
              v-if="goodsInfo.orderType == 4 && goodsInfo.orderStatus == 3"
              @click="operaConfirm('confirmDeliverGoods')"
            >退货</el-button>
          </div>
        </div>
        <div class="shopping-orderdetail-pub fl">
          <div class="shopping-orderdetail-steps fl">
            <div
              class="shopping-orderdetail-steps_li"
              v-for="(item,index) in orederLine"
              :key="index"
              :class="item.type"
            >
              <div class="shopping-order-steps_li-line fl">
                <div class="shopping-order-steps_li-lines fl"></div>
                <div class="shopping-order-steps_li-span fl"></div>
              </div>
              <div class="shopping-order-steps_content fl">
                <dl>
                  <dt>{{item.label}}</dt>
                  <dd v-if="goodsInfo.orderType == 3 && item.value == 3">{{goodsInfo.createDate}}</dd>
                  <dd v-if="goodsInfo.orderType == 3 && item.value == 4">{{goodsInfo.deliverDate}}</dd>
                  <dd v-if="goodsInfo.orderType == 3 && item.value == 5">{{goodsInfo.completeDate}}</dd>
                  <dd v-if="goodsInfo.orderType == 4 && item.value == 3">{{goodsInfo.createDate}}</dd>
                  <dd v-if="goodsInfo.orderType == 4 && item.value == 4">{{goodsInfo.deliverDate}}</dd>
                  <dd v-if="goodsInfo.orderType == 4 && item.value == 5">{{goodsInfo.completeDate}}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div class="shopping-orderdetail-pub fl">
          <div class="shopping-orderdetail-news fl">
            <div class="shopping-orderdetail-news_info fl">
              <img src="../../assets/images/shopping/home_icon_notice.png">
                  <span v-if="goodsInfo.orderStatus == 3">{{goodsInfo.createDate}}</span>
                  <span v-if="goodsInfo.orderStatus == 4">{{goodsInfo.deliverDate}}</span>
                  <span v-if="goodsInfo.orderStatus == 5">{{goodsInfo.completeDate}}</span>
              <span>{{goodsInfo_notice}}</span>
            </div>
            <div
              class="shopping-orderdetail-news_btn fr"
              v-if="goodsInfo.orderStatus == 4 || goodsInfo.orderStatus == 5"
            >
              <el-button
                plain
                class="shoppingbtn-plan shopp-btn-default"
                @click="operaConfirm('confirmlogistics')"
              >查看物流</el-button>
            </div>
          </div>
        </div>
        <div class="shopping-orderdetail-pub fl" v-if="goodsInfo.orderType == '3'">
          <div class="shopping-orderdetail-address fl">
            <span>收货人：{{goodsInfo.consignee || goodsInfo.deliveryAddressDTO.name}}</span>
            <span>联系电话：{{goodsInfo.consigneePhone || goodsInfo.deliveryAddressDTO.phone}}</span>
            <span>收货地址：{{goodsInfo.deliveryAddressName || goodsInfo.deliveryAddressDTO.address}}</span>
          </div>
        </div>
        <div class="shopping-orderdetail-pub fl">
          <div class="shopping-orderdetail-table fl">
            <el-table
              :data="goodsInfo.productInfoENTList"
              :header-cell-style="{background:'#EFF1F5',fontSize:'14px',padding:'7px 0',textAlign:'center'}"
              style="width: 100%"
            >
              <el-table-column label="商品信息">
                <template slot-scope="scope">
                  <div class="shopping-detail_goods-find">
                    <div class="shopping-detail_goods-find-img fl">
                      <img
                        :src="scope.row.productImgList.length > 0 && scope.row.productImgList[0].imgUrl"
                      >
                    </div>
                    <dl>
                      <dt>
                        {{scope.row.productName}}
                        <font>（{{scope.row.productSpec}}）</font>
                      </dt>
                      <dd>
                        <font
                          v-for="(item,index) in scope.row.productLabelENTList"
                          :key="item.id"
                          v-if="index < 3"
                        >{{item.labelName}}</font>
                      </dd>
                    </dl>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="单价" width="150">
                <template slot-scope="scope">
                  <p class="shopping-cen">{{ scope.row.price }}</p>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="150">
                <template slot-scope="scope">
                  <p class="shopping-cen">{{ scope.row.quantity }}</p>
                </template>
              </el-table-column>
              <el-table-column label="小计" width="150">
                <template slot-scope="scope">
                  <p class="shopping-cen">{{ scope.row.subtotal }}</p>
                </template>
              </el-table-column>
              <el-table-column label="实付" width="200">
                <template slot-scope="scope">
                  <p class="shopping-cen">{{ scope.row.subtotal }}</p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="shopping-orderdetail-prices shopping-orderdetail-pub fl">
          <div class="shopping-submit-price_info fr">
            <ul>
              <li>
                <label>商品件数</label>
                <span>
                  <font>{{totalPrice.goodsNum}}</font>件
                </span>
              </li>
              <li>
                <label>配件总价</label>
                <span>
                  <font>{{totalPrice.goodsPricePJ}}</font>元
                </span>
              </li>
              <li>
                <label>产品总价</label>
                <span>
                  <font>{{totalPrice.goodsPriceCP}}</font>元
                </span>
              </li>
              <li>
                <label>仪器总价</label>
                <span>
                  <font>{{totalPrice.goodsPriceYQ}}</font>元
                </span>
              </li>
              <li>
                <label>商品总价</label>
                <span>
                  <font>{{goodsInfo.totalAmount}}</font>元
                </span>
              </li>
              <li class="shopping-detail_all-price">
                <label>应付总额</label>
                <span>
                  <font>¥ {{goodsInfo.totalAmount}}</font>元
                </span>
              </li>
            </ul>
          </div>
        </div>
        <!-- 订单状态 -->
        <div class="shopping-order-typeinfo">
          <div class="shopping-order-red fl">
            <img src="../../assets/images/shopping/redbg.png" class="fl">
            <font v-if="goodsInfo.orderType == 3">补发单</font>
            <font v-if="goodsInfo.orderType == 4">退货单</font>
          </div>
        </div>
      </div>
    </div>
    <!-- model弹层 -->
    <shoppingModel :visibleModel="visibleModel" @operaCanel="operaCanel" @operaSure="operaSure"/>
  </div>
</template>
<script type="text/javascript">
import shoppingModel from "@/components/shoppingMall/shoppingModel";
import { viewAfterSalesOrder } from "@/api";
import shoppingPublic from "@/assets/js/shoppingPublic";

export default {
  name: "shopping-submit",
  components: {
    shoppingModel
  },
  data() {
    return {
      goodsInfo: {},
      goodsInfo_notice: "",
      orederLine: [],
      totalPrice: {
        goodsNum: 0,
        goodsPriceCP: 0,
        goodsPricePJ: 0,
        goodsPriceYQ: 0,
        goodsPriceGoods: 0,
        goodsPriceTotal: 0
      },
      visibleModel: ""
    };
  },
  created() {
    this.operaOrderDetails();
  },
  methods: {
    operaOrderDetails() {
      viewAfterSalesOrder({ id: this.$route.params.id }).then(res => {
        this.goodsInfo = res.obj;
        this.goodsInfo.productInfoENTList = this.goodsInfo.productInfoENTList
          ? this.goodsInfo.productInfoENTList
          : [];
        this.goodsInfo.productInfoENTList.forEach((val, index, arr) => {
          if (val.categoryCode == "CP") {
            this.totalPrice.goodsPriceCP += val.subtotal * 1;
          }
          if (val.categoryCode == "PJ") {
            this.totalPrice.goodsPricePJ += val.subtotal * 1;
          }
          if (val.categoryCode == "YQ") {
            this.totalPrice.goodsPriceYQ += val.subtotal * 1;
          }
        });
        this.totalPrice.goodsNum = this.goodsInfo.productInfoENTList.length;
        this.totalPrice.goodsPriceCP = shoppingPublic.computePrice(
          this.totalPrice.goodsPriceCP,
          2
        );
        this.totalPrice.goodsPricePJ = shoppingPublic.computePrice(
          this.totalPrice.goodsPricePJ,
          2
        );
        this.totalPrice.goodsPriceYQ = shoppingPublic.computePrice(
          this.totalPrice.goodsPriceYQ,
          2
        );
        this.goodsInfo_notice = shoppingPublic.systemNews(
          this.goodsInfo.orderStatus,
          null,
          this.goodsInfo.orderType
        );
        this.orederLine = this.operaOrderLine(this.goodsInfo.orderStatus);
        this.$store.commit('SEARCH_SHOPPING_GOODS','');
      });
    },
    operaOrderLine(statust) {
      let status = parseInt(statust);
      let statusArr = [
        { value: 3, label: "订单生成" },
        { value: 4, label: "订单发货" },
        { value: 5, label: "已完成" }
      ];
      if (status > 5) {
        statusArr.forEach((val, index, arr) => {
          if (val.value == 1) {
            val.type = "on";
          } else {
            val.type = "";
          }
        });
      }
      if (status <= 5) {
        statusArr.forEach((val, index, arr) => {
          if (val.value <= status) {
            val.type = "on";
          } else if (status == 5) {
            val.type = "on";
          } else {
            val.type = "";
          }
        });
      }
      return statusArr;
    },
    //取消订单-confirm
    operaConfirm(val) {
      let visibleModels = {};
      visibleModels.modelType = val;
      if(val == 'confirmGetGoods' || val == 'confirmDeliverGoods'){
        visibleModels.orderType = 2;
      }
      if (val == "confirmlogistics") {
        visibleModels.orderType = 2;
        visibleModels.imageSize = this.goodsInfo.productInfoENTList.length;
        visibleModels.imgUrl = this.goodsInfo.productInfoENTList[0].productImgList[0].imgUrl;
      }
      this.visibleModel = JSON.stringify(visibleModels);
    },
    //再次购买
    operaOldOrderDetails() {
      this.$router.push("/shoppingMall/shoppingOrderDetail/" + this.goodsInfo.originalOrderId);
    },
    //model公用返回方法
    operaSure(val) {
      this.visibleModel = "";
      this.operaOrderDetails();
    },
    operaCanel(val) {
      this.visibleModel = "";
    }
  }
};
</script>
<style type="text/css">
.shopping-orderdetail {
  position: relative;
  margin-top: 30px;
  background: #ffffff;
}
.shopping-orderdetail-top {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 80px;
  border-bottom: 1px solid #d5d9e3;
}
.shopping-orderdetail-top_infos {
  padding-left: 143px;
  font-size: 15px;
  color: #444444;
}
.shopping-orderdetail-top_infos span {
  margin-right: 30px;
}

.shoppingbtn-plan.el-button {
  list-style: none;
  padding: 0;
  border-radius: 5px !important;
}
.shopp-btn-default.el-button:hover,
.shopp-btn-default.el-button:focus {
  color: #f83c57;
  background: #fff0f2;
  border: 1px solid #f83c57;
}
.shopp-btn-danger.el-button:hover,
.shopp-btn-danger.el-button:focus {
  color: #ffffff;
  background: #df364e;
  border: 1px solid #f83c57;
}
.shopp-btn-default {
  width: 100px;
  height: 32px;
  color: #f83c57;
  border: 1px solid #f83c57;
}
.shopp-return.shopp-btn-default {
  width: 110px;
}
.shopp-btn-danger {
  width: 100px;
  height: 32px;
  color: #ffffff;
  background: #f83c57;
  border: none;
}
.shopping-orderdetail-top_btn {
  padding-right: 60px;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.shopping-orderdetail-pub {
  padding-left: 60px;
  padding-right: 60px;
  margin-top: 30px;
  width: 100%;
}
.shopping-orderdetail-table {
  width: 100%;
  border: 1px solid #d5d9e3;
}
.shopping-orderdetail-prices {
  padding-bottom: 80px;
  width: 100%;
}
.shopping-submit-price_info {
  width: 250px;
}
.shopping-submit-price_info ul {
  float: left;
  width: 100%;
}
.shopping-submit-price_info ul li {
  float: left;
  margin-top: 5px;
  width: 100%;
  font-size: 14px;
  color: #444444;
}
.shopping-submit-price_info ul li label {
  float: left;
  width: 60px;
}
.shopping-submit-price_info ul li span {
  float: right;
  text-align: right;
}
.shopping-submit-price_info ul li font {
  margin-right: 5px;
}
.shopping-submit-price_info ul .shopping-detail_all-price {
  margin-top: 23px;
  line-height: 24px;
}
.shopping-detail_all-price font {
  font-size: 24px;
  color: #f83c57;
}
.shopping-orderdetail-news {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 50px;
  background: #fbf1f3;
}
.shopping-orderdetail-news_info {
  flex: 1;
  font-size: 14px;
  color: #444444;
}
.shopping-orderdetail-news_info img {
  margin-left: 30px;
}

.shopping-orderdetail-news_info span {
  margin-left: 15px;
}
.shopping-orderdetail-news_btn {
  padding-right: 30px;
}
.shopping-orderdetail-address {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #f6f7f9;
}
.shopping-orderdetail-address span {
  float: left;
  margin-left: 25px;
  margin-right: 9px;
  font-size: 14px;
  color: #444444;
}
.shopping-order-typeinfo {
  position: absolute;
  top: 13px;
  left: 38px;
  width: 82px;
  height: 82px;
}
.shopping-order-green {
  width: 100%;
  color: #2ecfa7;
}
.shopping-order-red {
  width: 100%;
  color: #f83c57;
}
.shopping-order-gray {
  width: 100%;
  color: #999999;
}

.shopping-order-typeinfo font {
  float: left;
  margin-top: -55px;
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  transform: rotate(30deg);
  -ms-transform: rotate(30deg); /* Internet Explorer */
  -moz-transform: rotate(30deg); /* Firefox */
  -webkit-transform: rotate(30deg); /* Safari 和 Chrome */
  -o-transform: rotate(30deg); /* Opera */
}

/*进度条*/
.shopping-orderdetail-steps {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 35px;
  width: 100%;
}
.shopping-orderdetail-steps_li {
  width: 144px;
}
.shopping-order-steps_li-line {
  width: 100%;
  height: 16px;
}
.shopping-order-steps_li-lines {
  width: 100%;
  height: 4px;
  background: #d5d9e3;
}
.shopping-order-steps_li-span {
  float: left;
  margin-top: -10px;
  margin-left: 64px;
  width: 16px;
  height: 16px;
  background: #d5d9e3;
  border-radius: 50%;
}

.shopping-order-steps_content {
  width: 100%;
}
.shopping-order-steps_content dl {
  color: #d5d9e3;
}
.shopping-order-steps_content dl,
.shopping-order-steps_content dl dt,
.shopping-order-steps_content dl dd {
  float: left;
  width: 100%;
  text-align: center;
}
.shopping-order-steps_content dl dt {
  font-size: 15px;
  font-weight: bold;
}
.shopping-order-steps_content dl dd {
  font-size: 12px;
}

/*成功*/
.shopping-orderdetail-steps_li.on .shopping-order-steps_li-lines {
  background: #2ecfa7;
}
.shopping-orderdetail-steps_li.on .shopping-order-steps_li-span {
  background: #2ecfa7;
}
.shopping-orderdetail-steps_li.on .shopping-order-steps_content dl {
  color: #2ecfa7;
}
/*失败*/
.shopping-orderdetail-steps_li.error .shopping-order-steps_li-lines {
  background: #f83c57;
}
.shopping-orderdetail-steps_li.error .shopping-order-steps_li-span {
  background: #f83c57;
}
.shopping-orderdetail-steps_li.error .shopping-order-steps_content dl {
  color: #f83c57;
}
</style>


// WEBPACK FOOTER //
// src/components/shoppingMall/shoppingAfterDetail.vue